import React from "react";
import { Arc, Group } from "react-konva";

const SingleGate = ({ shape, shapeProps }) => {
	return (
		<Group
			key={shape.id}
			{...shapeProps}
			x={shape.x}
			y={shape.y}
			width={shape.width}
		>
			<Arc
				y={0}
				angle={90}
				innerRadius={0}
				outerRadius={shape.width}
				rotation={270}
				fill="transparent"
				stroke="black"
				strokeWidth={2}
			/>
		</Group>
	);
};

export default SingleGate;
